(function () {
    'use strict';

    angular.module("imApp").factory("olmRequisitionService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 786,
                    parameters: parms || {}
                });
            },
            listStocks: function (parms) {
                return $ihttp.post({
                    method: 787,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
